<template>
  <modal v-bind="$attrs" v-on="$listeners" :center="true">
    <template v-slot:body>
      <div v-if="checkingType == 'limit'" class="desc">
        {{ $t('study_sets.modals.modal_check.limit_desc') }}
      </div>
      <div v-if="checkingType == 'spell'" class="desc">
        {{ $t('study_sets.modals.modal_check.spell_desc') }}
      </div>
    </template>
    <template v-slot:footer>
      <primary-button class="confirm-back" ref="" @click.native="$emit('closed')" >
        {{ $t('study_sets.modals.modal_check.back_to_edit') }}
      </primary-button>
      <tertiary-button v-if="checkingType == 'spell'" class="confirm-continute" @click.native="handleContinue">
        {{ $t('study_sets.modals.modal_check.proceed') }}
      </tertiary-button>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/common/Modal'
import PrimaryButton from '@/components/common/buttons/PrimaryButton'
import TertiaryButton from '@/components/common/buttons/TertiaryButton'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    checkingType: {
      type: String,
      default: "limit"
    }
  },
  components: {
    Modal,
    PrimaryButton,
    TertiaryButton
  },
  data() {
    return {
    }
  },
  computed: {
    getTitle() {
      return this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, 'modals.delete.title'), {
        numberOfClasses: this.numberOfSelectedClasses
      })
    },
  },
  methods: {
    handleContinue() {
      this.$emit('proceed');
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';

.desc {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 32px;
  /* or 160% */
  text-align: center;
  /* Dark */
  color: #121131;
  width: 80%;
  margin: auto;
}

.elsa-button.confirm-back,
.elsa-button.confirm-back:hover {
  border-radius: 8px;
  text-transform: none;
}

.elsa-button.confirm-continute,
.elsa-button.confirm-continute:hover {
  border-radius: 8px;
  padding-left: 16px;
  padding-right: 16px;
}

::v-deep {
  .el-dialog.elsa-modal {
    .el-dialog__header,
    .el-dialog__body {
      //padding: 40px 40px 0 40px;
      // display: flex;
      background-color: white;
    }

    &.signup .el-dialog__body {
      padding: 0;
    }

    .el-dialog__header {
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      min-height: 27.5px;
    }

    .el-dialog__body {
      border-top: none;
      & > *:not(p):not(.info) {
        padding-bottom: 6px;
        display: flex;
        flex-direction: column;
      }
    }

    .el-dialog__footer {
      padding: 0 20px 48px 20px;
      justify-content: center;
    }
  }
}
.spell-check {
    border: none;
    padding: 0;
    font-size: 16px;
    color: red;
    text-decoration: underline;
}
.spell-check:hover {
  color: red;
  border-color: none;
}
</style>
